/*
 * Author: Roger
 * File Created: Wednesday, 24-08-14 09:53 pm
 * Last Modified: Monday, 24-10-28 04:19 pm, by Roger
 */

import {
  filledInputClasses,
  formHelperTextClasses,
  iconButtonClasses,
  inputAdornmentClasses,
  inputBaseClasses,
  styled,
  svgIconClasses,
  TextField,
} from '@mui/material';

export type mode = 'main' | 'vip';
interface GoInputProps {
  colorMode?: mode;
}

export const StyledGoInput = styled(TextField, {
  shouldForwardProp: (propName) => propName !== 'colorMode',
})<GoInputProps>(({ theme, colorMode = 'main' }) => ({
  width: '100%',

  [`.${filledInputClasses.root}`]: {
    padding: '10px 12px 10px 20px',
    borderRadius: '35px',
    background: 'transparent !important',
    border: '1px solid #848E9C',
  },

  [`& .${inputBaseClasses.root}`]: {
    background: theme.palette.common.white,
    [`&:hover`]: {
      background: theme.palette.common.white,
    },

    [`& .${inputBaseClasses.input}`]: {
      color: '#848E9C',
      fontSize: '14px',
      borderRadius: 0,
      [theme.breakpoints.only('xs')]: {
        fontSize: '12px',
      },
      [`&::placeholder`]: {
        color: 'rgba(132, 142, 156, 0.60)',
        fontSize: '14px',
        [theme.breakpoints.only('xs')]: {
          fontSize: '12px',
        },
      },
    },
  },

  [`& .${inputAdornmentClasses.positionEnd}`]: {
    position: 'relative',
    right: '-12px',

    [`& .${iconButtonClasses.root}`]: {
      color: colorMode === 'main' ? theme.palette.common.white : '#1E1E1E',
      aspectRatio: '1 / 1',
      width: '32px',
      marginRight: '2px',
      zIndex: 1,
      [theme.breakpoints.only('xs')]: {
        marginRight: '6px',
      },

      background: colorMode === 'main' ? theme.palette.primary.main : '#F2C89B',
      [`&:hover`]: {
        background:
          colorMode === 'main'
            ? theme.palette.primary.main
            : 'rgb(242,200,155,.9)',
      },
      [`&:disabled`]: {
        background:
          colorMode === 'main'
            ? theme.palette.primary.main
            : 'rgb(242,200,155,.7)',
      },
      [`& .${svgIconClasses.root}`]: {
        width: '18px',
        height: '18px',
        color: colorMode === 'main' ? theme.palette.common.white : '#000',
      },
    },
  },

  [`& .${formHelperTextClasses.error}`]: {
    color: '#FFF !important',
  },
}));
